import {useDateTimeFormatter, useFormatNumber} from 'platform/locale';

import i18n from '@dms/i18n';

import type {GridPdfExportCallback} from 'features/eag-grid';

import {createTireSetRequestPdfData} from '../utils/createTireSetRequestPdfData';

const PDF_FILENAME = 'tire-set-requests.pdf';
const BRAND = 'OMNETIC';

export function useTireSetRequestPdfExport(): GridPdfExportCallback {
  const formatDateTime = useDateTimeFormatter();
  const formatNumber = useFormatNumber();

  return async (context, signal) => {
    signal.throwIfAborted();
    const records = createTireSetRequestPdfData(context, {
      dateTime: (value) => formatDateTime('dateTimeShort', value),
      integer: (value) => formatNumber(value, 0),
    });
    const selection = i18n.t('page.datagrid.labels.numberOfSelectedRows', {
      selectedRows: records.length,
    });
    const exportedAt = formatDateTime('dateTimeShort', context.exportedAt);
    const {createTireSetRequestPdf} = await import('../utils/createTireSetRequestPdf');
    signal.throwIfAborted();
    const bytes = await createTireSetRequestPdf(
      {
        title: i18n.t('page.tiresInventory.labels.tiereSetRequests'),
        brand: BRAND,
        metadata: `${selection} | ${i18n.t('general.actions.export')} ${exportedAt}`,
        records,
      },
      signal
    );
    return {bytes, filename: PDF_FILENAME};
  };
}
